import React, { useState, useEffect } from 'react'
import { useSearchParams } from '@remix-run/react'
import {
    InputGroup,
    Input,
    InputRightElement,
    Button,
    useColorModeValue
} from '@chakra-ui/react'

import theme from '../../../../Config/theme'

import { FaSearch } from "react-icons/fa";

const HeroSearchInput = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const inputBgColor = useColorModeValue('gray.50', 'gray.900')
    const borderColor = useColorModeValue(theme.borderColor.borderColorLight, theme.borderColor.borderColorDark)
    const textColor = useColorModeValue('black', 'white')

    const [keywords, setKeywords] = useState('')

    const handleSearch = () => {
        searchParams.set('keywords', keywords)
        searchParams.set('page', 1)
        setSearchParams(searchParams)
    }

    useEffect(() => {
        setKeywords(searchParams.get('keywords') || '')
    }, [])
    return (
        <InputGroup size={'lg'}>
            <Input
                borderRadius={'full'}
                focusBorderColor={theme.default.defaultColor}
                placeholder={'keywords'}
                variant={'filled'}
                _focus={{ bgColor: inputBgColor }}
                _hover={{}}
                bgColor={inputBgColor}
                border={'1px'}
                borderColor={borderColor}
                value={keywords}
                onChange={e => setKeywords(e.target.value)}
                onKeyDown={e => {
                    e.key === 'Enter' && handleSearch()
                }}
                color={textColor}
                size={'lg'}
            />
            <InputRightElement width={'auto'} align={'center'} pr={1}>
                <Button
                    size={'md'}
                    bgColor={theme.default.defaultColor}
                    w={24}
                    borderRadius={'full'}
                    _focus={{}}
                    _active={{}}
                    _hover={{}}
                    onClick={handleSearch}
                >
                    <FaSearch />
                </Button>
            </InputRightElement>
        </InputGroup>
    )
}

export default HeroSearchInput
